import { useMutation, UseMutationOptions } from '@tanstack/react-query'
import { Entities } from 'src/enums'
import { AdminNotification, ManageAdminNotification } from 'src/api'
import { useApiInstance } from './useApiInstance'

interface RequestParams {
  userId: number
  options?: Omit<
  UseMutationOptions<unknown, Error, ManageAdminNotification, AdminNotification>,
    'queryKey' | 'queryFn'
  >;
}

export const useUserAdminNotificationRequest = ({
  userId,
  options,
}: RequestParams) => {
  const api = useApiInstance()

  return useMutation<unknown, Error, ManageAdminNotification, AdminNotification>(
    [Entities.Users, userId, 'userAdminNotificationsManage'],
    async (payload: ManageAdminNotification) => {
      const { data } = await api.v1AdminUsersUserIdAdminNotificationsManagePut(userId, payload)
      return data
    },
    {
      ...options,
    },
  )
}
